import React, { FC } from "react";
import "./WsLimitCardsList.scss";
import { useNavigate } from "react-router-dom";
import { useWindows } from "@app/overlay";
import { OPEN_FILTER_QUERY_PARAM } from "@app/router/queryParams";
import { ListItem } from "@src/components/business-list";
import { CardHeader } from "@shared/ui/card-header";
import { BusinessList } from "@src/components/business-list";
import { BusinessDivisionValue } from "@src/components/business-data-display";
import { useBusinessListQuery } from "@src/hooks/useBusinessListQuery";
import { useUrlFilter } from "@shared/hooks/useUrlFilter";
import { useUrlParamTrigger } from "@shared/hooks/useUrlParamTrigger";
import { limitCardsServices, type LimitCard, type LimitCardFilter } from "@src/api/stock/limitCards";
import { wsLimitCardsListWindows } from "./wsLimitCardsList.windows";

export const WsLimitCardsList: FC = () => {
    const windows = useWindows();
    const navigate = useNavigate();
    const filterState = useUrlFilter<LimitCardFilter>();

    const list = useBusinessListQuery<LimitCard, LimitCardFilter>({
        queryKey: "workshop.wsLimitCards",
        filter: filterState.filter,
        queryFn: async (flt, signal) => {
            const result = await limitCardsServices.load(
                { flt, include: ["Sender", "SenderSection", "Receiver", "ReceiverSection"] },
                { signal },
            );
            return result.items;
        },
        getId: (item) => item.Code,
    });

    const openFilterWindow = (): void => {
        wsLimitCardsListWindows.filter.open(windows, {
            initialFilter: filterState.filter,
            onApply: (flt) => {
                filterState.applyFilter(flt, true);
            },
        });
    };

    useUrlParamTrigger(OPEN_FILTER_QUERY_PARAM, () => {
        openFilterWindow();
    });

    return (
        <div className="ws_limit_cards_list_page">
            <CardHeader
                text="Лимитные карты УП (Приход)"
                buttons={[
                    { type: "button", text: "Поиск", srcIcon: "/images/common/options.svg", onClick: openFilterWindow },
                ]}
            />
            <BusinessList list={list} onOpenFilter={openFilterWindow}>
                {list.data.map((item) => (
                    <ListItem
                        key={item.Code}
                        title={`Лимитная карта №${item.Num}`}
                        props={[
                            {
                                label: "Отправитель",
                                value: <BusinessDivisionValue division={item?.Sender} section={item?.SenderSection} />,
                            },
                            {
                                label: "Получатель",
                                value: <BusinessDivisionValue division={item?.Receiver} section={item?.ReceiverSection} />,
                            },
                        ]}
                        onClick={() => {
                            navigate(`${item.Code}`);
                        }}
                    />
                ))}
            </BusinessList>
        </div>
    );
};
